import { useEffect, useRef, useState } from 'react';
import sliderimg from '../../../styles/images/cnbc-default-image.webp';
import Link from 'next/link';
import { requests, fileUrl } from '../../../services/Requests';
import GetData from '../../../services/GetData';
import VideoDuration from '../../HelperComponents/VideoDuration';
import Thumbnail from '../../Thumbnail';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import Title from '../../Title';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HorizontalProgramsSlider = ({ title }) => {
  const [programs, setPrograms] = useState<any[]>([]);

  useEffect(() => {
    GetData(`${requests.programs}?limit=20&pageNo=1`, {}, 'get', false)
      .then((res) => {
        setPrograms(res?.data?.response?.programs);
      })
      .catch((err) => {
        console.warn(err);
      });
  }, []);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  
  return (
    <>
      <div className="newsSliderText newsSlider2Text video_newsSlider_wrap">
        <div className="TileBar scrollbarHeader heading_border">
          <div className="row">
            <div className="col-sm-6">
              <div className="float-end">
                <Title styles={'TitleBar'}>
                  <div className="yellowTitle">
                    <h3>{title}</h3>
                  </div>
                </Title>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="sliderArrows text-start">
                <button
                  className="slider-arrow arrow-prev"
                  ref={navigationPrevRef}
                >
                  Previous
                </button>
                <button
                  className="slider-arrow arrow-next"
                  ref={navigationNextRef}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
          <div className="clearfix"></div>
        </div>
        <Swiper
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          dir="rtl"
          slidesPerView={4}
          spaceBetween={20}
          slidesPerGroup={1}
          breakpoints={{
            // '1800': { slidesPerView: 3 },
            '1024': { slidesPerView: 4 },
            '992': { slidesPerView: 4 },
            '575': { slidesPerView: 3 },
            '375': { slidesPerView: 1.5 },
            '320': { slidesPerView: 1.5 },
          }}
          pagination={false}
          modules={[Navigation, Pagination]}
          className="mySwiper"
        >
          {
            // show episodes
            programs?.length > 0 &&
            programs.map((program: any, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <div className="slider-item" key={index}>
                    <div className="NewsBox ">
                      <Link href={`/program/${program.id + '/' + program.title}`}>
                        <div className="newsImage">
                          <a href="#" aria-label="Go to 105">
                            <Thumbnail showThumbnail={true}
                              className="img-fluid"
                              src={
                                program?.thumbnail?.url
                                  ? program?.thumbnail?.url
                                  : program?.thumbnail?.path
                                    ? fileUrl + program?.thumbnail?.path
                                    : sliderimg.src
                              }
                            />
                            <VideoDuration data={program?.video} />
                          </a>
                        </div>
                      </Link>
                      <div className="newscontent">
                        <h5>
                          <Link href={`/program/${program.id + '/' + program?.title}`}>
                            <a href="#" aria-label="Go to 106">{program && program?.title}</a>
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          }
        </Swiper>
      </div>
    </>
  );
};

export default HorizontalProgramsSlider;
